import { games } from "../content/siteContent";
import { useAppStore } from "../store/useAppStore";
import { useProjectsCarouselStore } from "../store/useProjectsCarouselStore";
import { AboutScene } from "./sections/AboutScene";
import { ContactScene } from "./sections/ContactScene";
import { GameRouteScene } from "./sections/GameRouteScene";
import { ProjectsScene } from "./sections/ProjectsScene";
import { StudioScene } from "./sections/StudioScene";
import { TeamScene } from "./sections/TeamScene";
import { getSectionSceneWeight } from "./transitions/sectionMotion";

export function SceneManager() {
  const currentSection = useAppStore((state) => state.currentSection);
  const targetSection = useAppStore((state) => state.targetSection);
  const transitionProgress = useAppStore((state) => state.transitionProgress);
  const isTransitioning = useAppStore((state) => state.isTransitioning);
  const reducedMotion = useAppStore((state) => state.reducedMotion);
  const experienceMode = useAppStore((state) => state.experienceMode);
  const activeGameSlug = useAppStore((state) => state.activeGameSlug);
  const activeProjectIndex = useProjectsCarouselStore((state) => state.activeIndex);
  const projectCarouselProgress = useProjectsCarouselStore((state) => state.rotationProgress);
  const isStudioProjectsTransition = currentSection === "studio" && targetSection === "projects" && isTransitioning;

  if (experienceMode === "detail") {
    return <GameRouteScene slug={activeGameSlug ?? games[0]?.slug ?? null} />;
  }

  return (
    <>
      <StudioScene
        reducedMotion={reducedMotion}
        transitionProgress={isStudioProjectsTransition ? transitionProgress : 0}
        transitioningToProjects={isStudioProjectsTransition}
        weight={getSectionSceneWeight("studio", currentSection, targetSection, transitionProgress, isTransitioning)}
      />
      <ProjectsScene
        rotationProgress={projectCarouselProgress}
        reducedMotion={reducedMotion}
        transitionProgress={isStudioProjectsTransition ? transitionProgress : 0}
        transitioningFromStudio={isStudioProjectsTransition}
        weight={getSectionSceneWeight("projects", currentSection, targetSection, transitionProgress, isTransitioning)}
      />
      <TeamScene
        reducedMotion={reducedMotion}
        weight={getSectionSceneWeight("team", currentSection, targetSection, transitionProgress, isTransitioning)}
      />
      <AboutScene
        reducedMotion={reducedMotion}
        weight={getSectionSceneWeight("about", currentSection, targetSection, transitionProgress, isTransitioning)}
      />
      <ContactScene
        weight={getSectionSceneWeight("contact", currentSection, targetSection, transitionProgress, isTransitioning)}
      />
    </>
  );
}
